import * as React from "react"
import type { SVGProps } from "react"
const SvgDelete = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M7 21.86q-.82 0-1.41-.59A2 2 0 0 1 5 19.86v-13a1 1 0 0 1-.71-.29A1 1 0 0 1 4 5.86q0-.43.29-.72A1 1 0 0 1 5 4.87h4q0-.43.29-.72a1 1 0 0 1 .71-.28h4q.42 0 .71.29.3.28.29.7h4q.42 0 .71.3.3.28.29.7c-.01.43-.1.53-.29.72a1 1 0 0 1-.71.29v13q0 .83-.59 1.41a2 2 0 0 1-1.41.59zm10-15H7v13h10zm-7 11q.42 0 .71-.29a1 1 0 0 0 .29-.71v-7a1 1 0 0 0-.29-.72 1 1 0 0 0-.71-.28 1 1 0 0 0-.71.28 1 1 0 0 0-.29.72v7q0 .42.29.71.29.3.71.29m4 0q.42 0 .71-.29a1 1 0 0 0 .29-.71v-7a1 1 0 0 0-.29-.72 1 1 0 0 0-.71-.28 1 1 0 0 0-.71.28 1 1 0 0 0-.29.72v7q0 .42.29.71.29.3.71.29" />
  </svg>
)
export default SvgDelete
